import { CORE_API } from "../constants";
import { getData, postData } from "./common.service";
class ActivitySerivce {

  static getCulturalPractice = (cropId: string): Promise<Array<TCultActivityType>> => {
    const filterQuery = {
      order: ["fromDayOfSowing ASC"],
      where: {
        cropId: cropId,
      },
    };

    const url = `/cultural-practices/?filter=${JSON.stringify(filterQuery)}`;
    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static loadActivitiesType = (): Promise<Array<TActivityType>> => {
    const url = `/farm-activity-types/?filter=${JSON.stringify({ order: ["created_date ASC"] })}`;
    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static saveActivity = (payload: TFarmActivityType) => {
    const url = "/farm-activities";
    return postData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
      body: payload,
    });
  };
}
export default ActivitySerivce;

export type TActivityType = {
  displayName?: string,
  created_date: string,
  id: string,
  name: string
}

export type TCurrency = {
  currency: string,
  cost: number,
}

export type TCultActivityType = {
  displayName: string;
  created_date: string;
  id: string;
  activity: string;
  cropId: string;
  fromDayOfSowing: number;
  uptoDayOfSowing: number;
  name?: string;
};

export type TFarmActivityType = {
  notes?: string;
  culturalPracticeId?: string;
  done: boolean;
  activityCost?: TCurrency;
  plotId: string;
  farmActivityTypeId: string;
  doneDate: Date;
  cropId: string;
};

export type TActivityItem = TCultActivityType & {
  name: string; // Additional property if needed
};